import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetBufferedUxpRuntimeErrorsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBufferedUxpRuntimeErrorsQuery = { __typename?: 'Query', getBufferedUxpRuntimeErrors: Array<{ __typename?: 'UxpRuntimeErrorPayload', id: string, message: string, operation?: string | null, severity: Types.ErrorSeverity, source: string, stack?: string | null, timestamp: string }> };


export const GetBufferedUxpRuntimeErrors = /*#__PURE__*/ gql`
    query GetBufferedUxpRuntimeErrors {
  getBufferedUxpRuntimeErrors {
    id
    message
    operation
    severity
    source
    stack
    timestamp
  }
}
    ` as unknown as DocumentNode<GetBufferedUxpRuntimeErrorsQuery, GetBufferedUxpRuntimeErrorsQueryVariables>;

          

          export const useGetBufferedUxpRuntimeErrorsQuery = (options?:QueryHookOptions<GetBufferedUxpRuntimeErrorsQuery, GetBufferedUxpRuntimeErrorsQueryVariables>) => useQuery(GetBufferedUxpRuntimeErrors, options);

          

          export type GetBufferedUxpRuntimeErrorsQueryOptions = QueryHookOptions<GetBufferedUxpRuntimeErrorsQuery, GetBufferedUxpRuntimeErrorsQueryVariables>;

          

          export const useGetBufferedUxpRuntimeErrorsLazyQuery = (options?:LazyQueryHookOptions<GetBufferedUxpRuntimeErrorsQuery, GetBufferedUxpRuntimeErrorsQueryVariables>) => useLazyQuery(GetBufferedUxpRuntimeErrors, options);

          

          export type GetBufferedUxpRuntimeErrorsQueryResult = ReturnType<typeof useGetBufferedUxpRuntimeErrorsQuery>;

          
